module.exports = __webpack_public_path__ + "img/entrance_plant_5@2x.b9cbd0bf.jpg";